export const EXTENSION_NAME = "icon-siam"
export const ATTRACTION_TYPE = "post-category-iconsiam-0-attraction"
export const LUXURY_TYPE = "post-category-iconsiam-0-luxury"
export const VAT_REFUND_CATEGORY_REF = "local-category-iconsiam-0-vat-refund"
